// TODO: This is place holder for RN, web wont be using
// This will be replaced with a configurable storage solution
// For now, it maintains compatibility with existing @commons/helpers/storage
class ReactNativeAuthStorage {
    async setItem(key, value) {
        try {
            this.storage.setItem(key, value);
        } catch (error) {
            console.error('ReactNativeAuthStorage setItem failed:', error);
        }
    }
    async getItem(key) {
        try {
            const value = this.storage.getItem(key);
            return value ?? null;
        } catch (error) {
            console.error('ReactNativeAuthStorage getItem failed:', error);
            return null;
        }
    }
    async removeItem(key) {
        try {
            this.storage.removeItem(key);
        } catch (error) {
            console.error('ReactNativeAuthStorage removeItem failed:', error);
        }
    }
    async clear() {
        try {
            this.storage.clear();
        } catch (error) {
            console.error('ReactNativeAuthStorage clear failed:', error);
        }
    }
    getAllValues() {
        try {
            return this.storage.getAllValues();
        } catch (error) {
            console.error('ReactNativeAuthStorage getAllValues failed:', error);
            return [];
        }
    }
    constructor(options){
        try {
            // Try to import the existing LocalStorage from commons
            const { LocalStorage } = require('@commons/helpers/storage');
            this.storage = new LocalStorage(options);
        } catch (error) {
            console.error('ReactNativeAuthStorage: Failed to initialize LocalStorage:', error);
            throw new Error('LocalStorage dependency not available. Make sure @commons/helpers/storage is installed.');
        }
    }
}

export { ReactNativeAuthStorage };
//# sourceMappingURL=ReactNativeStorage.js.map
